import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17.102 3.4A10 10 0 0 0 6 4V3a1 1 0 0 0-2 0v3a1 1 0 0 0 .684.949l3 1a1 1 0 0 0 .632-1.898l-1.189-.396a8 8 0 0 1 11.525 10.79 1 1 0 1 0 1.663 1.11A10.003 10.003 0 0 0 17.102 3.4M4 12a1 1 0 1 0-2 0c0 .753.085 1.498.25 2.222a1 1 0 0 0 1.95-.444A8 8 0 0 1 4 12m1.861 5.13a1 1 0 0 0-1.534 1.283 10 10 0 0 0 3.282 2.572 1 1 0 0 0 .878-1.797 8 8 0 0 1-2.626-2.058m11.088 3.56a1 1 0 1 0-.99-1.738A8 8 0 0 1 12.005 20a1 1 0 1 0 .001 2 10 10 0 0 0 4.942-1.31"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14 8a1 1 0 1 0-2 0v4h-2a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1z" })
);
var SvgHistoryFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var HistoryFilled_default = SvgHistoryFilled;

export { HistoryFilled_default as default };
